import { createContext, useContext } from "react";
import type { useShippingRates } from "./useShippingRates";

export interface ShippingLabelContextType {
  ratesQuery: ReturnType<typeof useShippingRates>;
  calculatedInputs: string | null;
  setCalculatedInputs: (inputs: string | null) => void;
}

export const ShippingLabelContext =
  createContext<ShippingLabelContextType | null>(null);

export const useShippingLabelContext = () => {
  const context = useContext(ShippingLabelContext);
  if (!context) {
    throw new Error(
      "useShippingLabelContext must be used within ShippingLabelProvider",
    );
  }
  return context;
};
